// extracted by mini-css-extract-plugin
export var center = "Title-module--center--3DiJ2";
export var left = "Title-module--left--5hRw9";
export var mb = "Title-module--mb--98h7j";
export var right = "Title-module--right--179c9";
export var subtitle = "Title-module--subtitle--OMAYc";
export var title = "Title-module--title--Dncfh";